<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>司机列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 卡片 -->
        <el-card class="box-card" style="margin-top:20px">
            <!-- 搜索  新增-->
            <el-form
                    :inline="true"
                    :model="searchForm"
                    :rules="searchRules"
                    ref="searchForRef"
                    label-width="80px"
                    autocomplete="on"
                    size="mini"
            >
                <el-form-item label="司机名称">
                    <el-select
                            v-model="searchForm.owner_id"
                            filterable
                            style="width: 180px;"
                            remote
                            reserve-keyword
                            placeholder="请输入关键词"
                            :remote-method="ownerRemoteMethod"
                            :loading="ownerLoading">
                        <el-option
                                v-for="item in ownerList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-date-picker
                        v-model="searchForm.start_end_date"
                        type="daterange"
                        align="right"
                        size="mini"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="startEndOptions">
                </el-date-picker>
                <el-button type="success" size="mini" @click="searchSubmit()">搜索</el-button>

                <el-form-item>
                    <el-dropdown>
                        <el-button type="primary">
                            更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item  @click.native="addData" >新增</el-dropdown-item>
                            <el-dropdown-item  @click.native="addData" >导出</el-dropdown-item>
                            <el-dropdown-item  @click.native="addData" >打印</el-dropdown-item>
                            <el-dropdown-item  @click.native="delAll" >删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-form-item>
            </el-form>
            <!-- 表格 -->
            <el-table
                    ref="multipleTable"
                    :data="mList"
                    stripe
                    border
                    size="mini"
            >
                <el-table-column :index="indexMethod" type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column
                        width="120"
                        label="电话"
                        prop="tel"
                        :show-overflow-tooltip='true'
                >
                </el-table-column>
                <el-table-column
                        label="司机姓名"
                        width="105"
                        prop="name"
                >
                </el-table-column>

                <el-table-column
                        label="日期"
                        width="115"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.register_time | dateFormat }}</span>
                    </template>
                </el-table-column>

                <el-table-column
                        label="所属员工"
                        width="115"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.employee?scope.row.employee.name_cn:'' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="状态"
                        width="115"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.status==1?'':'未审' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="备注"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.remark}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="150">
                    <template slot-scope="scope">
                        <el-button @click="auditClick(scope.row)"  type="text" size="small">审核</el-button>
                        <el-button @click="delClick(scope.row)"  type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="block" style="margin-top:10px">
                <el-pagination
                        background
                        size="mini"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-sizes="[10, 20, 30, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </el-card>

        <!--  司机审核信息 -->
        <el-dialog :title="title" size="mini" :visible.sync="dialogFormVisible" width="550px">
            <el-form size="mini" :model="form" :rules="rules" ref="form" label-width="80px">
                <el-form-item label="司机名称" prop="name">
                    <el-input v-model="form.name" autocomplete="off" placeholder="请输入司机名称"></el-input>
                </el-form-item>

                <el-form-item label="是否通过" prop="name">
                    <el-radio v-model="form.status" label="1">是</el-radio>
                    <el-radio v-model="form.status" label="0">否</el-radio>
                </el-form-item>
                <el-form-item label="选择员工">
                    <el-select
                            v-model="form.employee_id"
                            filterable
                            style="width: 180px;"
                            remote
                            reserve-keyword
                            placeholder="请输入关键词"
                            :remote-method="employeeRemoteMethod"
                            :loading="employeeLoading" prop="employee_id">
                        <el-option
                                v-for="item in employeeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini"  @click="reset_dialogForm('form')">取 消</el-button>
                <el-button size="mini"  type="primary" @click="submitForm('form')">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import moment from 'moment'     //日期时间转换

    export default {
        name: "ownerList",
        components: {
        },
        props: {},
        data() {
            return {
                ownerLoading:'',
                ownerList:[],
                ownerStates:[],

                startEndOptions:{
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                // 搜索
                searchForm: {
                    owner_id:'',
                    name: "",
                    start_end_date:'',
                    start_time:'',
                    end_time:''
                },
                searchRules: {
                    name: [
                        { required: true, message: "请输入司机名称", trigger: "blur" }
                    ],
                },
                // 数据
                mList: [],
                pageNum:1,// 当前页码
                pageSize:10,// 每页大小
                total:0,//总条目数

                showType: '',

                roleList: [],

                rules: {
                    name: [
                        { required: true, message: '请输入司机名称', trigger: 'blur' },
                        {
                            min: 1,
                            max: 15,
                            message: "长度在 1 到 15 个字符",
                            trigger: "blur",
                        }
                    ],

                },

                dialogFormVisible: false,
                title: '',
                form: {
                    name: '',
                    status:'',
                    id:'',
                    employee_id:''
                },

                employeeLoading:'',
                employeeList:[],
                employeeStates:[],

            };
        },
        created() {
            this.showType = this.$route.query.showType;
            console.log(this.showType,888);
            this.DataList()
            //  this.departData()
        },
        mounted() {
        },
        filters: {
            /**
             * @param {
             *
             * }
             */
            //时间格式化
            dateFormat(add_time) {
                if (add_time == undefined) {
                    return "";
                }
                return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
            },
            statusFilter(status) {
                if (status == 0) {
                    return "待审核";
                } else if (status == 1) {
                    return "已审核";
                } else if (status == 2) {
                    return "已出单";
                } else if (status == 3) {
                    return "已完成";
                } else if (status == 4) {
                    return "取保";
                } else if (status == 5) {
                    return "退单";
                }
            },

        },
        methods: {
            auditClick(row){
                this.dialogFormVisible=true;
                this.form.status=row.status;
                this.form.name=row.name;
                this.form.id=row.id;
            },
            ownerRemoteMethod(query){
                if (query !== '') {
                    this.applicantLoading = true;
                    let param={
                        keywords:query,
                        operator_id:sessionStorage.getItem('user_id'),
                        company_id:sessionStorage.getItem('company_id'),
                        access_token:sessionStorage.getItem('token'),
                    }
                    console.log('param------',param)
                    this.$axios.OwnerList(param).then(res=>{
                        if(res.code == 200){
                            this.ownerStates = res.data;
                        }
                    }).catch(error=>{
                        console.log(error);
                    })
                    setTimeout(() => {
                        this.ownerLoading = false;
                        this.ownerList = this.ownerSet.filter(item => { // 这里的this.list，换为this.applicantSet
                            return item.name;
                        });
                    }, 1000);
                } else {
                    this.ownerList = [];
                }
            },
            indexMethod(index) {
                return (this.pageNum - 1) * this.pageSize + index + 1
            },
            DataList(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                    showType: this.showType,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    owner_id:this.searchForm.owner_id,
                    start_time:this.searchForm.start_time,
                    end_time:this.searchForm.end_time
                }
                this.$axios.ownerByLgsListP(param).then(res=>{
                    if(res.code == 200){
                        this.mList = res.data.data;
                        this.total = res.data.total;
                    }
                }).catch(error=>{
                    console.log(error);
                })
            },
            // 设置每页条数
            handleSizeChange(newSize) {
                this.pageSize = newSize
                this.DataList()
            },
            // 分页跳转
            handleCurrentChange(newPage) {
                this.pageNum = newPage
                this.DataList()
            },
            departData(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                }
                this.$axios.findTree(param).then(res=>{
                    if(res.code == 200){
                        this.rightslist = res.data.data
                    }
                }).catch(error=>{
                    console.log(error);
                })
            },

            // 新增
            addData() {
                this.title = '新增'
                this.form = {
                    name: '',
                }
                this.dialogFormVisible = true
            },
            delClick(){
                this.$confirm('请是否确认删除该司机吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    callback: (action) => {
                        if (action === 'confirm') {
                            // const val = this.checkedDetail
                            // val.forEach((val, index) => {
                            //   this.tableData.forEach((v, i) => {
                            //     if (val.xh === v.xh) {
                            //       this.tableData.splice(i, 1)
                            //     }
                            //   })
                            // })
                            // this.$message({
                            //   message: '删除成功，记得保存修改喔！',
                            //   type: 'success'
                            // })
                            // this.$refs.tb.clearSelection()
                            // return
                        } else {
                            this.$message({
                                message: '已取消删除操作',
                                type: 'warning'
                            })
                            return
                        }
                    }
                })
            },
            handelEdit(index) {
                this.id = index.data.row.id
                this.title = '编辑'
                this.form = {
                    name: this.name,
                }
                this.dialogFormVisible = true
                // this.form = {...row};
                // 或者
                this.form = JSON.parse(JSON.stringify(index.data.row))
            },

            reset_dialogForm(formName) {
                this.dialogFormVisible = false
                this.$nextTick(() => {
                    this.$refs[formName].resetFields()
                })
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(!this.id){
                            const param = {
                                name: this.form.name,
                                employee_id: this.form.employee_id,
                                operator_id: sessionStorage.getItem('user_id'),
                                company_id: sessionStorage.getItem('company_id'),
                                access_token: sessionStorage.getItem('token'),
                                id:this.form.id,
                                status:this.form.status
                            }
                            this.$axios.auditOwner(param).then(res =>{
                                if(res.code == 200){
                                    this.DataList()
                                    this.$message.success(res.msg)
                                    this.dialogFormVisible = false
                                }else{
                                    this.$message.error(res.msg);
                                }
                            })
                        }else{
                            const param = {
                                id: this.form.id,
                                name: this.form.name,
                                operator_id: sessionStorage.getItem('user_id'),
                                company_id:sessionStorage.getItem('company_id'),
                                access_token:sessionStorage.getItem('token'),
                            }
                            this.$axios.insuranceCorpSave(param).then(res =>{
                                if(res.code == 200){
                                    this.$message.success(res.msg)
                                    this.DataList()
                                    this.dialogFormVisible = false
                                }else{
                                    this.$message.error(res.msg);
                                }
                            })
                        }

                    }
                })
            },
            searchSubmit() {

                if(this.searchForm.start_end_date){
                    const [start_date,end_date]=this.searchForm.start_end_date;
                    this.searchForm.start_time=start_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+start_date.getDate();
                    this.searchForm.end_time=end_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+end_date.getDate();
                }
                console.log('searchForm',this.searchForm.name)
                this.pageNum=1;
                this.mList=[];
                this.total=0;
                this.DataList();
            },

            handelDel(e) {
                console.log(e);
                this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const param = {
                        operator_id: sessionStorage.getItem('user_id'),
                        company_id:sessionStorage.getItem('company_id'),
                        access_token:sessionStorage.getItem('token'),
                        id: e.data.row.id,
                    }
                    this.$axios.insuranceCorpDel(param).then(res=>{
                        if(res.code == 200){
                            this.$message.success(res.msg);
                            this.DataList()
                        }else{
                            this.$message.error(res.msg);
                        }
                    }).catch(error=>{
                        console.log(error);
                    })
                }).catch(() => {
                    // 点击取消:不删除了
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                    this.DataList()
                });
                this.teamDialog = false
            },


            employeeRemoteMethod(query){
                if (query !== '') {
                    this.applicantLoading = true;
                    let param={
                        keywords:query,
                        operator_id:sessionStorage.getItem('user_id'),
                        company_id:sessionStorage.getItem('company_id'),
                        access_token:sessionStorage.getItem('token'),
                    }
                    this.$axios.employeeList(param).then(res=>{
                        if(res.code == 200){
                            console.log('employee------',res.data)
                            this.employeeStates = res.data;
                        }
                    }).catch(error=>{
                        console.log(error);
                    })
                    setTimeout(() => {
                        this.employeeLoading = false;
                        this.employeeList = this.employeeSet.filter(item => { // 这里的this.list，换为this.applicantSet
                            return item.name;
                        });
                    }, 1000);
                } else {
                    this.employeeList = [];
                }
            },
        },
        computed: {
            employeeSet() {
                return this.employeeStates.map(item => {
                    return {id: `${item.id}`, name: `${item.name_cn}-${item.mobile}`};
                });
            },
            ownerSet() {
                return this.ownerStates.map(item => {
                    return {id: `${item.id}`, name: `${item.name}-${item.name}`};
                });
            },
        },
    };
</script>
<style>

</style>
